import { render, staticRenderFns } from "./batchSection.vue?vue&type=template&id=04d3f6e7&scoped=true&"
import script from "./batchSection.vue?vue&type=script&lang=js&"
export * from "./batchSection.vue?vue&type=script&lang=js&"
import style0 from "./batchSection.vue?vue&type=style&index=0&id=04d3f6e7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04d3f6e7",
  null
  
)

export default component.exports